const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const elusApi = {
  list:        (opts)        => request('/elus',                  { query: opts }),
  get:         (id)          => request(`/elus/${id}`),
  adminList:   (token, opts) => request('/admin/elus',            { token, query: opts }),
  adminGet:    (token, id)   => request(`/admin/elus/${id}`,      { token }),
  adminCreate: (token, body) => request('/admin/elus',            { method: 'POST',   token, body }),
  adminUpdate: (token, id, b)=> request(`/admin/elus/${id}`,      { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)   => request(`/admin/elus/${id}`,      { method: 'DELETE', token }),
};

export const ELU_TITLES = [
  { id: 'all',        lbl: 'Tous' },
  { id: 'maire',      lbl: 'Maire' },
  { id: 'adjoint',    lbl: 'Adjoint·e' },
  { id: 'conseiller', lbl: 'Conseiller·ère' },
];

export const TITLE_LABEL = Object.fromEntries(ELU_TITLES.map((t) => [t.id, t.lbl]));
